import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { size } from "lodash";
import {
  useBrightbotActions,
  useBrightbotStore,
} from "../../../store/useBrightbotStore";

type Props = { display: boolean };

const AssistantSelector = ({ display }: Props) => {
  const { setActiveAssistant } = useBrightbotActions();
  const activeAssistant = useBrightbotStore.use.activeAssistant();
  const assistants = useBrightbotStore.use.assistants();

  if (!display) return <></>;

  const selectActiveAssistant = (event: SelectChangeEvent) => {
    const assistant = assistants.find(
      (assistant) => assistant.assistant_id === event.target.value
    );
    setActiveAssistant(assistant);
  };

  return (
    <FormControl sx={{ minWidth: 120 }}>
      <InputLabel size="small" id="assistant-select-label">
        Assistant
      </InputLabel>
      <Select
        labelId="assistant-select-label"
        id="demo-simple-select"
        value={activeAssistant?.assistant_id || ""}
        label="Assistant"
        size="small"
        onChange={selectActiveAssistant}
      >
        {size(assistants) > 0 &&
          assistants.map((assistant, index) => (
            <MenuItem
              value={assistant?.assistant_id}
              key={assistant?.assistant_id || index}
            >
              {assistant?.graph_id}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default AssistantSelector;
